import { PExtraSmall } from '../elements/Text';
import styled from 'styled-components';
import { AssessmentTestContext } from '../../contexts/assessment-test';
import { useActiveTestStep } from '../../hooks/assessment-test/use-active-step';
import React from 'react';
import dayjs from 'dayjs';
import {
  getStepSecondsSpent,
  getAssessmentSecondsSpent,
} from '../../contexts/assessment-test/helpers';
import { useTimeTicker } from '../../hooks/assessment-test/use-time-ticker';
import {
  STEP_EXPIRATION_WARNING_SECONDS,
  TEST_EXPIRATION_WARNING_SECONDS,
} from './TestTimeoutHandler';

const TimeSpent = styled(PExtraSmall)<{ hasWarning?: boolean }>`
  color: ${({ theme, hasWarning }) =>
    hasWarning ? theme.colors.buttonSecondary : theme.colors.textRegular};
  font-weight: 400;
  margin-top: 0;
  padding-bottom: 0;
`;

export function StepTimer() {
  const { step } = useActiveTestStep();
  const now = useTimeTicker(1000);
  const secondsSpent = getStepSecondsSpent(step, now);
  const formattedTime = dayjs()
    .startOf('day')
    .second(secondsSpent)
    .format(secondsSpent > 3600 ? 'HH:mm:ss' : 'mm:ss');
  return (
    <TimeSpent hasWarning={secondsSpent > STEP_EXPIRATION_WARNING_SECONDS}>
      {formattedTime}
    </TimeSpent>
  );
}

export function TotalTimer() {
  const [state] = React.useContext(AssessmentTestContext);
  const now = useTimeTicker(1000);
  const secondsSpent = getAssessmentSecondsSpent(state, now);
  const formattedTime = dayjs()
    .startOf('day')
    .second(secondsSpent)
    .format(secondsSpent > 3600 ? 'HH:mm:ss' : 'mm:ss');
  return (
    <TimeSpent hasWarning={secondsSpent > TEST_EXPIRATION_WARNING_SECONDS}>
      {formattedTime}
    </TimeSpent>
  );
}
